<template>
  <error-boundary module="login-module">
    <hr-module v-if="!state.loading" class="login-module" no-header blue logo>
      <hr-module-header
        :title="
          t('login-module:title', {
            name: company.name,
            interpolation: { escapeValue: false },
          })
        "
        class="login-module__title"
      ></hr-module-header>
      <h-r-module-section class="login-module__description">
        {{ t(`login-module:description`) }}
      </h-r-module-section>
      <h-r-module-section>
        <div class="login-module__image">
          <img src="../../static/images/welcome@2x.png" />
        </div>
      </h-r-module-section>
      <h-r-module-section>
        <button
          type="primary"
          class="btn btn-primary lg hr-blue-purple"
          @click="getStarted"
        >
          {{ t('login-module:get-started') }}
        </button>
      </h-r-module-section>
    </hr-module>
  </error-boundary>
</template>

<script>
import HrModule from '@/components/hr-module';
import HRModuleSection from '@/components/HRModuleSection';
import HrModuleHeader from '@/components/hr-module-header.vue';
import store from '@/store';
import router from '@/router';
import auth from '@/lib/request/svc-url/auth';
import jwtToObject from '@/lib/jwt-to-object';
import setGlobalApiEndpoint from '@/lib/set-global-api-endpoint';
import { reactive, computed } from 'vue';
import t from '@/lib/i18next';
import { HR_ONBOARDING_STATES } from '../core/onboarding-states';
import { logWebHrError } from '@/core/logger/log-wrapper';
import ErrorBoundary from '@/components/error-boundary.vue';

export default {
  name: 'login-module',
  components: {
    ErrorBoundary,
    HrModule,
    HRModuleSection,
    HrModuleHeader,
  },
  props: {
    tempToken: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const state = reactive({
      loading: true,
    });
    const company = computed(() => store.state.company);
    const progress = computed(() => store.getters.state);
    const session = store.getters.session;
    let onboardingId = null;

    function getStarted() {
      router.push({
        name: 'OnboardingModule',
        params: { onboardingId: onboardingId },
      });
    }

    async function initialize() {
      if (onboardingId && session) {
        router.push({ name: 'OnboardingModule' });
        return true;
      }

      const keys = props.tempToken.split(';');
      const tempJwt = keys?.[1];

      onboardingId = keys?.[0];

      try {
        if (!tempJwt) {
          throw new Error('missing temp JWT');
        }

        const jwt = await auth(tempJwt);
        setGlobalApiEndpoint(jwtToObject(jwt));

        store.dispatch('setSession', { token: onboardingId, jwt });

        await store.dispatch(
          'dispatchLoadTenantSettings',
          store.state.tenantId,
        );
        await store.dispatch('getDocuments', onboardingId);

        state.loading = false;

        if (
          progress.value === HR_ONBOARDING_STATES['SUBMITTED'] ||
          progress.value === HR_ONBOARDING_STATES['APPROVED']
        ) {
          return router.push({
            name: 'view-manager-module',
            params: { isEmployee: true },
          }); // TODO: rename this module
        } else if (progress.value === HR_ONBOARDING_STATES['REVIEW']) {
          return router.push({
            name: 'view-module',
            params: {
              onboardingId: onboardingId,
            },
          });
        }
      } catch (e) {
        logWebHrError({
          message: 'Failed to initialize during login-module',
          source: 'login-module.vue',
          metadata: {
            onboardingId,
          },
          error: e,
        });
        return router.push({ name: 'BlockModule' });
      }

      // TODO: add the session logic in here
    }
    initialize();
    return {
      t,
      getStarted,
      company,
      state,
    };
  },
};
</script>

<style scoped>
.login-module__image img {
  max-width: 600px;
  margin: 18px 0;
}
.login-module .hr-blue-button {
  width: 100%;
  max-width: 400px;
  background: rgb(56, 37, 179);
}

.login-module__title {
  font-size: 24px;
  color: #1e163c;
}

.login-module__description {
  font-size: 18px;
  color: #6c6a72;
}

.hr-blue-purple {
  margin-top: 24px;
  background: #3d1cba;
  padding: 8px 20px;
  border-radius: 10px;
}

@media screen and (max-width: 787px) {
  .login-module__image img {
    max-height: initial;
    width: 100%;
  }
}
</style>
